import { Box, Menu, createStyles } from '@mantine/core';
import { IconButton } from '@repo/foundations';
import type { ReactNode } from 'react';

interface OverflowMenuProps {
	menuItems: ReactNode[];
}

interface OverflowMenuWrapperProps {
	children: ReactNode;
	className?: string;
	menuItems: ReactNode[];
}

const useStyles = createStyles((theme) => ({
	wrapper: {
		position: 'relative',
	},
	menuButton: {
		position: 'absolute',
		top: 0,
		right: 0,
	},
	dropdown: {
		padding: theme.spacing['2xs'],
		minHeight: 'fit-content',
	},
}));

function OverflowMenuContent({ menuItems }: OverflowMenuProps) {
	const { classes } = useStyles();

	return (
		<Menu position="right-start" withinPortal>
			<Menu.Target>
				<IconButton iconName="dots" variant="tertiary" tooltip="More actions" />
			</Menu.Target>
			<Menu.Dropdown className={classes.dropdown}>
				{menuItems.filter((item) => item !== null)}
			</Menu.Dropdown>
		</Menu>
	);
}

export function OverflowMenu(props: OverflowMenuProps) {
	return <OverflowMenuContent {...props} />;
}

function OverflowMenuWrapper({
	children,
	className,
	menuItems,
}: OverflowMenuWrapperProps) {
	const { classes, cx } = useStyles();
	return (
		<Box className={cx(classes.wrapper, className)}>
			{children}
			<Box className={classes.menuButton}>
				<OverflowMenuContent menuItems={menuItems} />
			</Box>
		</Box>
	);
}

OverflowMenu.Wrapper = OverflowMenuWrapper;
